import { format, parseISO } from 'date-fns';
import * as R from 'ramda';
import { formatDateForExport } from 'utils/helpers/format';

const minWidth = 150;

const HistoricalInventoryColumns = [
  {
    cellClassName: 'css-heap-redact',
    field: 'productShortName',
    headerName: 'Product',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'productIdName',
    headerName: 'Product ID',
    minWidth,
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'volume',
    headerName: 'Volume (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'locationShortName',
    headerName: 'Location',
    minWidth,
  },
  {
    field: 'locationIdName',
    headerName: 'Location ID',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'originShortName',
    headerName: 'Origin',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'originIdName',
    headerName: 'Origin ID',
    minWidth,
  },
  {
    field: 'shipmentId',
    headerName: 'Shipment Request ID',
    minWidth,
    renderCell: ({ row }) => (R.prop('shipmentId', row) ? R.prop('shipmentId', row) : null), // remove commas from numbers
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerShortName',
    headerName: 'Inventory Owner',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerIdName',
    headerName: 'Inventory Owner ID',
    minWidth,
  },
  {
    field: 'rvp',
    headerName: 'RVP',
    minWidth,
    type: 'number',
  },
  {
    field: 'shipmentDate',
    headerName: 'Shipment Date',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('shipmentDate', row)
        ? format(parseISO(R.prop('shipmentDate', row)), 'MM/dd/yyyy')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'rateEffDate',
    headerName: 'Rate Effective Date',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('rateEffDate', row)
        ? format(parseISO(R.prop('rateEffDate', row)), 'MM/dd/yyyy')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'reserved',
    headerName: 'Reserved',
    minWidth,
  },
  {
    field: 'reconsControlShortName',
    headerName: 'Recons Control Location',
    minWidth,
  },
  {
    field: 'reconsControlIdName',
    headerName: 'Recons Control Location ID',
    minWidth,
  },
  {
    field: 'historyDate',
    headerName: 'History Date',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('historyDate', row)
        ? format(parseISO(R.prop('historyDate', row)), 'MM/dd/yyyy HH:mm:ss')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'ton',
    headerName: 'Ton',
    minWidth,
  },
];

export default HistoricalInventoryColumns;
